module.exports = __webpack_public_path__ + "img/success.3871ca61.svg";